import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';
import {Divider, Form, Row} from "antd";
import {RTLButton, RTLCol} from "../RTLKit";
import SelectField from "../formFields/SelectField";
import TextField from "../formFields/TextField";
// import CheckBoxField from "../formFields/CheckBoxField";

class WizardFormThirdPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chooseProducts : 0,
            chooseServices : 0,
            chooseTicketValue : 0,
            isForce:false
        };
    }

    componentDidMount() {
        this.props._reduxForm.getItem()
    }

    __getProductTree() {
        let productList
        if(this.props._reduxForm.initialValues)
            productList = this.props._reduxForm.initialValues.products_tree;
        let dataSource = [];

        if (productList) {

            for (let i = 0; i < productList.length; i++) {

                dataSource.push(
                    {label: productList[i].title, value: productList[i]._id, key: i,products:productList[i].products}
                );
            }
        }
        return dataSource;
    }

    __fixProductObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    __getFixtureList() {
        let fixtureList
        if(this.props._reduxForm.initialValues)
            fixtureList = this.props._reduxForm.initialValues.fixtures;

        let dataSource = [];

        if (fixtureList) {

            for (let i = 0; i < fixtureList.length; i++) {

                dataSource.push(
                    {label: fixtureList[i].title, value: fixtureList[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    render() {
        const {handleSubmit, pristine, previousPage, submitting} = this.props;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        if (this.props.initialValues) {
            this.props.initialValues.mode = this.state.mode
        }

        /* ----- find selected branch city  -----*/
        let categoryList = this.__getProductTree();
        let productList = [];
        let disabled = true

        if(this.state.fixtureType === 'ORDER_TYPE_REPAIR'){
            if(this.state.chooseServices.length === 0 || this.state.chooseServices === 0) {
                disabled = true
            }else
                disabled = false
        }

        if(this.state.fixtureType === 'ORDER_TYPE_BUY'){
            if(this.state.chooseProducts === 0) {
                disabled = true
            }else
                disabled = false
        }

        if(this.state.fixtureType === 'ORDER_TYPE_CUSTOMER_TICKET'){
            if(this.state.chooseTicketValue === 0) {
                disabled = true
            }else
                disabled = false
        }

        if (this.state.catId) {
            for (let i = 0; i < categoryList.length; i++) {
                if (categoryList[i]['value'] === this.state.catId) {
                    productList = categoryList[i]['products'];
                    productList = this.__fixProductObject(productList);
                }
            }
        }


        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Divider orientation="left">خدمات / فروش دستگاه</Divider>
                </Row>
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle">
                        <Row gutter={16}>

                            <Field
                                name="order_type"
                                component={SelectField}
                                label="سرویس"
                                list={[{label: 'خدمات', value: 'ORDER_TYPE_REPAIR'}, {label: 'فروش دستگاه', value: 'ORDER_TYPE_BUY'}, {label: 'تیکت مشتری', value: 'ORDER_TYPE_CUSTOMER_TICKET'}]}
                                onChange={(fixture_type) => this.setState({fixtureType: fixture_type})}
                            />
                            {
                                this.state.fixtureType === 'ORDER_TYPE_REPAIR' ?
                                    <Field
                                        name="fixtures"
                                        component={SelectField}
                                        label="سرویس"
                                        list={this.__getFixtureList()}
                                        mode="multiple"
                                        onChange={(fixture) => this.setState({chooseServices: fixture})}
                                    />
                                : null
                            }
                            {
                                this.state.fixtureType === 'ORDER_TYPE_BUY' ?
                                    <Field
                                        name="product_category"
                                        component={SelectField}
                                        label="دسته محصولات"
                                        list={categoryList}
                                        onChange = {(catId) => { this.setState({catId : catId})}  }
                                    />
                                : null
                            }
                            {
                                this.state.catId ?
                                    <Field
                                        name="product"
                                        component={SelectField}
                                        label="محصولات"
                                        list={productList}
                                        onChange={(product) => this.setState({chooseProducts: product})}
                                    />
                                : null
                            }
                            {
                                this.state.fixtureType === 'ORDER_TYPE_CUSTOMER_TICKET'?
                                    <Field
                                        name="user_ticket_value"
                                        component={SelectField}
                                        // type="text"
                                        label="عنوان تیکت"
                                        placeholder="عنوان تیکت را انتخواب کنید"
                                        list={[
                                            {label: 'تماس گرفته شد.', value: 'WERE_CONTACTED'},
                                            {label: 'خودشان تعویض می کنند.', value: 'THEY_CHANGE_THEMSELVES'},
                                            {label: 'پاسخ ندادند.', value: 'THEY_DID_NOT_ANSWER'},
                                            {label: 'خاموش بود.', value: 'IT_IS_OFF'},
                                            {label: 'بلاک لیست.', value: 'BLOCK_LIST'},
                                            {label: 'خودشان تماس میگیرند.', value: 'THEY_CALL_THEMSELVES'},
                                            {label: 'عدم تمایل به دریافت سرویس.', value: 'RELUCTANCE_TO_RECEIVE_SERVICE'},
                                            {label: 'بازدید رایگان.', value: 'FREE_VISIT'},
                                            {label: 'متفرقه', value: 'MISCELLANEOUE'},
                                            {label: 'تماس مجدد', value: 'CALL_BACK'},
                                        ]}
                                        onChange={(user_ticket_value) => this.setState({chooseTicketValue: user_ticket_value})}
                                    />
                                : null
                            }
                            {
                                this.state.fixtureType === 'ORDER_TYPE_REPAIR'?
                                <Field
                                    name="isForce"
                                    component={TextField}
                                    type="checkbox"
                                    label="خدمت فوری / اولویت دار"
                                    defaultValue={false}
                                    onChange={(val) => this.setState({isForce : val})}
                                />
                                : null
                            }
                            {
                                this.state.fixtureType === 'ORDER_TYPE_REPAIR' || this.state.fixtureType === 'ORDER_TYPE_BUY' || this.state.fixtureType === 'ORDER_TYPE_CUSTOMER_TICKET'?
                                    <Field
                                        name="description"
                                        component={TextField}
                                        type="text"
                                        label="توضیحات"
                                        placeholder="توضیحات"
                                    />
                                : null
                            }
                            {/* {
                                this.state.fixtureType === 'ORDER_TYPE_CUSTOMER_TICKET'?
                                    <Field
                                        name="update_user_ticket"
                                        component={TextField}
                                        type="checkbox"
                                        label="تیکت قبلی این مشتری ویرایش شود (این مورد جایگذین تیکت قبلی شود)"
                                        onChange={(update_user_ticket) => this.setState({update_user_ticket: update_user_ticket})}
                                        defaultValue={false}
                                    />
                                : null
                            } */}
                        </Row>
                    </RTLCol>
                </Row>
                <Row>
                    <RTLButton type="primary"  shape="round" htmlType="submit" disabled={disabled} className="login-form-button">
                        مرحله بعد
                    </RTLButton>
                    <RTLButton className="backBtn" type="default" shape="round" onClick={previousPage}>
                        مرحله قبل
                    </RTLButton>
                </Row>
            </form>
        );
    }
};

export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(WizardFormThirdPage);
